import ConfigurableText from './_configurable-text.js'
import SportsDisplayFormat from './_sports-display-format.js'
import ScoreCount from './_score-count.js'
import RedCard from './_red-card.js'

export default {
  name: 'MiniScoreboard',
  values: {
    gameActionsIndication: {
      soccer: {
        redCard: {
          visible: true,
          animated: true,
        },
        score: {
          animated: true,
        },
      },
    },
    padding: 0,
    scoreColumn: {
      margin: '0 0 0 5px',
      minWidth: '10px',
    },
    showSegmentIndicators: false,
    segmentIndicators: {
      top: -20,
      text: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    rowDirection: false,
    rowContainer: {
      away: undefined,
      home: undefined,
    },
    scoresTextMain: {
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    scoresTextSecondary: {
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    scoresColumn: {
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    serverIndicator: {
      color: undefined,
      width: '5px',
    },
    sportsDisplayFormat: {
      configSet: SportsDisplayFormat,
      configValues: {},
    },
    stretch: false,
    allowAmericanLayout: true,
    threeWayLayout: false,
    scoreCount: {
      configSet: ScoreCount,
      configValues: {},
    },
    redCard: {
      configSet: RedCard,
      configValues: {},
    },
  },
  meta: {
    extendable: true,
  },
}
